// store/modalStore.ts
import { create } from 'zustand';

export type ModalType =
    | 'confirm'      // 확인 모달
    | 'alert'        // 알림 모달
    | 'delete'       // 삭제 확인 모달
    | 'form'         // 폼 모달
    | null;

interface ModalState {
    isOpen: boolean;
    type: ModalType;
    title: string;
    message: string;
    data?: any;
    onConfirm?: () => void;
    onCancel?: () => void;
}

interface ModalActions {
    openModal: (options: Partial<ModalState>) => void;
    closeModal: () => void;
    confirm: () => void;
    cancel: () => void;
}

const initialState: ModalState = {
    isOpen: false,
    type: null,
    title: '',
    message: '',
    data: null,
    onConfirm: undefined,
    onCancel: undefined,
};

export const useModalStore = create<ModalState & { actions: ModalActions }>((set, get) => ({
    ...initialState,

    actions: {
        openModal: (options) => {
            set((state) => ({
                ...state,
                isOpen: true,
                ...options,
            }));
        },

        closeModal: () => {
            set(initialState);
        },

        confirm: () => {
            const { onConfirm } = get();
            if (onConfirm) {
                onConfirm();
            }
            get().actions.closeModal();
        },

        cancel: () => {
            const { onCancel } = get();
            if (onCancel) {
                onCancel();
            }
            get().actions.closeModal();
        },
    },
}));

// 유틸리티 함수들
export const useModal = () => {
    const { openModal, closeModal } = useModalStore((state) => state.actions);

    return {
        // 확인 모달
        confirm: (title: string, message: string, onConfirm: () => void) => {
            openModal({
                type: 'confirm',
                title,
                message,
                onConfirm,
            });
        },

        // 알림 모달
        alert: (title: string, message: string) => {
            openModal({
                type: 'alert',
                title,
                message,
            });
        },

        // 삭제 확인 모달
        confirmDelete: (message: string, onConfirm: () => void) => {
            openModal({
                type: 'delete',
                title: '삭제 확인',
                message,
                onConfirm,
            });
        },

        close: closeModal,
    };
};